import styled from 'styled-components';
import { COLORS } from '../../../../utils/styles';

export const LabelError = styled.label`
  color: ${COLORS.red};
  font-size: 1rem;
`;



// WEBPACK FOOTER //
// ./src/views/common/components/Labels/index.jsx